import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// グローバルスコープにReactを公開
window.React = React;
window.ReactDOM = ReactDOM;

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
